import axios from 'axios';

export default {
  getUsers({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/user/get`,
        params: ctx,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('insertUsers', resp.data);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  removeUser({ commit, state }, id) {
    return new Promise((resolve, reject) => {
      commit('removeUserRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/user/destroy`,
        params: { id },
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('removeUserRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('removeUserRequestError', err);
          reject(err);
        });
    });
  },
  addUser({ commit, state }, { payload, event }) {
    return new Promise((resolve, reject) => {
      commit('addUserRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/user/add`,
        params: payload,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('addUserRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('addUserRequestError', err);
          reject(err);
        });
    });
  },
  updateUser({ commit, state }, { payload, event }) {
    return new Promise((resolve, reject) => {
      commit('updateUserRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/user/update`,
        params: payload,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('updateUserRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('updateUserRequestError', err);
          reject(err);
        });
    });
  }
};
